import classNames from 'classnames'

import type {BuildId} from '../../../../../types'
import BuildStatusLink from '../../../../common/BuildStatus/BuildStatusLink/BuildStatusLink.container'

import styles from './MatrixGridRow.css'

type Props = {
  className?: string
  buildId: BuildId | undefined
  isVisible: boolean
}

function MatrixGridBuildStatus({buildId, isVisible}: Props) {
  const renderStatus = () => (buildId ? <BuildStatusLink buildId={buildId} /> : '-')
  return (
    <div className={classNames(styles.body, styles.column, styles.build)}>
      <div
        className={classNames(styles.columnValue, {
          [styles.visible]: isVisible,
        })}
      >
        {renderStatus()}
      </div>
    </div>
  )
}

export default MatrixGridBuildStatus
